import React, { useMemo } from 'react';
import { useLocation } from 'react-router-dom-v5';
import Worksheet from 'spw-components/worksheet/programming';
import { isDepartmentScenario } from 'spw-components/worksheet/utils';
import {
  useScenarioOrTotalProgramExportable,
  useVariantsOverride,
} from 'spw-programming-projects/downloads/exportables/hooks';

const WorksheetExportable: React.FunctionComponent = () => {
  const {
    currentScenario,
    currentProject,
    scenarios,
    currentBuilding,
    projectSpaceTypes,
    departments,
  } = useScenarioOrTotalProgramExportable();
  useVariantsOverride();
  const location = useLocation();
  const urlParams = new URLSearchParams(location?.search);
  const category = urlParams.get('category');
  const isOpen = urlParams.get('is_open') === 'true';
  const shouldShowClientFacingNames =
    urlParams.get('show_client_facing_names') === 'true';

  const shouldRender = useMemo(() => {
    let isAllDataAvailable = Boolean(
      currentScenario?.id &&
        currentProject?.id &&
        scenarios.length &&
        projectSpaceTypes.length &&
        currentBuilding
    );

    if (isDepartmentScenario(currentScenario)) {
      isAllDataAvailable = Boolean(isAllDataAvailable && departments.length);
    }

    return isAllDataAvailable;
  }, [
    currentBuilding,
    currentScenario,
    currentProject,
    scenarios,
    projectSpaceTypes,
    departments,
  ]);

  return shouldRender ? (
    <div className="content">
      <Worksheet
        isRenderingForExport
        isWorksheetOpenForDownload={isOpen}
        downloadParams={category ? { category } : {}}
        clientFacingNamesAreVisible={shouldShowClientFacingNames}
      />
    </div>
  ) : null;
};

export default WorksheetExportable;
